import { logWrapper } from '../utils';

export default {
  signerInfoModel: [
    'runtimeConstant',
    function (runtimeConstant) {
      function SignerInfo(data) {
        this.name = data.Name;
        this.effectiveDateString = data.EffectiveDateString
          ? new Date(Date.parse(data.EffectiveDateString)).format('dd/mm/yyyy')
          : null;
        this.expirationDateString = data.ExpirationDateString
          ? new Date(Date.parse(data.ExpirationDateString)).format('dd/mm/yyyy')
          : null;
        this.signatureDate = data.SignatureDate
          ? new Date(Date.parse(data.SignatureDate)).format(
              'dd/mm/yyyy HH:MM:ss'
            )
          : null;
      }

      function run() {
        try {
          return SignerInfo;
        } catch (error) {
          // eslint-disable-next-line no-console
          console.error(error);
        }
      }

      // Wrap the setup function with logWrapper for debugging purposes
      return logWrapper(run, runtimeConstant.isDebugModels)();
    },
  ],
};
